module.exports = __webpack_public_path__ + "img/Add.c114d99b.png";